export enum PromotionRewardTarget {
  Bonus = 'Bonus',
  Cash = 'Cash',
  FreeSpins = 'FreeSpins',
  Coins = 'Coins',
  InstantWheel = 'InstantWheel',
  BettyPoints = 'BettyPoints',
}

export const RewardNamesMapDesktop: Record<
  PromotionRewardTarget,
  string
> = {
  Bonus: 'rewardsCashDesktop',
  FreeSpins: 'rewardsSpinsDesktop',
  Coins: 'rewardsCoinsDesktop',
  InstantWheel: 'rewardsWheelDesktop',
  BettyPoints: 'rewardsCoinsDesktop',
  Cash: 'rewardsCashDesktop',
}

export const RewardNamesMapMob: Record<
  PromotionRewardTarget,
  string
> = {
  Bonus: 'rewardsCashMob',
  FreeSpins: 'rewardsSpinsMob',
  Coins: 'rewardsCoinsMob',
  InstantWheel: 'rewardsWheelMob',
  BettyPoints: 'rewardsCoinsMob',
  Cash: 'rewardsCashMob',
}
